import { AuthenticationContext, adalFetch, withAdalLogin  } from 'react-adal'

export const endpoint = '44bdb687-c0c3-4f9a-85b6-a4c9a0055a2c'

const adalConfig = {
    tenant: '9d018226-59aa-4566-bd12-0316c4486c94',
    clientId: '44bdb687-c0c3-4f9a-85b6-a4c9a0055a2c',
    // postLogoutRedirectUri: window.location.origin,
    // redirectUri: 'http://localhost:3000/',
    cacheLocation: 'localStorage',
    endpoints: {
        api: endpoint,
    },
}

export const authContext = new AuthenticationContext(adalConfig)

export const adalApiFetch = (fetch, url, options) =>
  adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);